import { useQuery } from "@tanstack/react-query";
import apis from "#store/api";
import { DataCollectionApiResponse } from "./types";

export const RESPONDER_TIME_LOGS_KEY = "responder-time-logs";

export interface ResponderTimeLog {
    id?: string;
    timeIn?: Date;
    timeOut?: Date;
    status?: number;
    locationFrom?: string;
    locationTo?: string;
    duration?: string; // Duration in ticks or milliseconds
    mileage?: number;
}

interface GetResponderTimeLogsParams {
    responderId?: string;
    skip?: number;
    take: number;
}

// Fetch responder time logs list
export const useResponderTimeLogs = (params: GetResponderTimeLogsParams) => {
  return useQuery({
    queryKey: [RESPONDER_TIME_LOGS_KEY, params],
    queryFn: async () => {
      const response = await apis.responderTimeLogs.getResponderTimeLogsList({ params });
      return response.data as DataCollectionApiResponse<ResponderTimeLog>;
    },
  });
};